export default __webpack_public_path__ + "static/media/smiley-05.96c97db9.png";